import FiltersOptionState from './schema/FiltersOptionState';
import { createStore } from 'satcheljs';

export default createStore<FiltersOptionState>('filtersOptionState', {
    trustedListsOnly: null,
    contactsTrusted: null,
    blockContentFromUnknownSenders: null,
});
